import { Component, h } from '@stencil/core';

import URLS from '../app-root/urls';
const pageInfo = {
  pageURL: URLS.AppWiki,
  pageTitle: 'Wiki Zento & Descriere Completă - ZENTO Magento 2 SaaS',
  pageDescription: 'Descriere completă a produsului Zento, soluția eCommerce Software-as-a-Service construită cu Magento 2 și un frontend PWA pe un hosting Cloud cu Kubernetes și Serverless',
  keywords: "magento, magento2, pwa, saas, kubernetes, serverless, aws, cloud, ui, ux, design, total cost of ownership, tco, erp, page builder"
}

@Component({
  tag: 'app-wiki',
  styleUrl: 'style.scss',
  shadow: false
})

export class AppWiki {
  static data = [
    {
      title: "General",
      description: [
        "Secțiunea aceasta este un punct de start excelent pentru a înțelege Zento. Secțiunea este focusată pe ce este Zento și de ce este cea mai bună soluție pentru magazinul tău, după care, putem vedea cum face Zento acest lucru.",
      ],
      articles: [
        {
          title: "De ce Zento?",
          icon: '../../assets/media/wiki/overview/icon_whyzento.svg',
          url: URLS.AppWikiOverviewWhyzento,
        },
        // {
        //   title: "Ce este un PWA?",
        //   icon: '../../assets/media/wiki/overview/icon_pwa.svg',
        //   url: URLS.AppWikiOverviewPwa,
        // },
        {
          title: "Total Cost of Ownership",
          icon: '../../assets/media/wiki/overview/icon_tco.svg',
          url: URLS.AppWikiOverviewTco,
        }
      ]
    },
    {
      title: "Design & UX",
      description: [
        "Designul și experiența utilizatorului determină relația clientului cu brandul tău, deci este unul dintre cele mai importante aspecte pentru magazinul tău.",
        "În această secțiunea vom trece prin filosofia noastră de design și cum facem magazinul tău să iasă în evidență și să câștige loialitatea clienților tăi.",
      ],
      articles: [
        {
          title: "Viziunea de Design",
          icon: '../../assets/media/wiki/design/icon_designvision.svg',
          url: URLS.AppWikiDesignVision,
        },
        {
          title: "Design General & UX",
          icon: '../../assets/media/wiki/design/icon_general.svg',
          url: URLS.AppWikiDesignGeneralDesignAndUx,
        },
        // {
        //   title: "Catalog",
        //   icon: '../../assets/media/wiki/design/icon_catalog.svg',
        //   url: '/wiki/design-and-ux/catalog',
        // },
        // {
        //   title: "Search",
        //   icon: '../../assets/media/wiki/design/icon_search.svg',
        //   url: '/wiki/design-and-ux/search',
        // },
        // {
        //   title: "Cart & Checkout",
        //   icon: '../../assets/media/wiki/design/icon_cartcheckout.svg',
        //   url: '/wiki/design-and-ux/cart-and-checkout',
        // },
        // {
        //   title: "Design Studio",
        //   icon: '../../assets/media/wiki/design/icon_designstudio.svg',
        //   url: '/wiki/design-and-ux/design-studio',
        // }
      ]
    },
    // {
    //   title: "Features",
    //   description: [
    //     "A few of Zento's propriatary functionality offers visitors and shop administrators all the state-of-the-art features they need to have a great experience.",
    //   ],
    //   articles: [
    //     {
    //       title: "Page Builder",
    //       icon: '../../assets/media/wiki/features/icon_pagebuilder.svg',
    //       url: '/wiki/features/page-builder',
    //     },
    //     {
    //       title: "Import & Export",
    //       icon: '../../assets/media/wiki/features/icon_importexport.svg',
    //       url: '/wiki/features/import-and-export',
    //     },
    //     {
    //       title: "Migration",
    //       icon: '../../assets/media/wiki/features/icon_migration.svg',
    //       url: '/wiki/features/migration',
    //     },
    //     {
    //       title: "Shipping Suite",
    //       icon: '../../assets/media/wiki/features/icon_shipping.svg',
    //       url: '/wiki/features/shipping-suite',
    //     }
    //   ]
    // },
    {
      title: "Hosting",
      description: [
        "Scopul este simplu: uptime perfect, încărcare rapidă și scalare eficientă. Pentru a atinge aceste obiective, Zento rulează pe cea mai avansată tehnologie de hosting în cloud-ul AWS (Amazon Web Services) și folosește cele mai noi arhitecturi Serverless și Kubernetes existente.",
      ],
      articles: [
        {
          title: "Ce este Cloud Hosting?",
          icon: '../../assets/media/wiki/hosting/icon_cloudhosting.svg',
          url: URLS.AppWikiHostingWhatiscloudhosting,
        },
        {
          title: "Architectură Generală",
          icon: '../../assets/media/wiki/hosting/icon_architecture.svg',
          url: URLS.AppWikiHostingArchitecture,
        },
        // {
        //   title: "PWA în Lambda",
        //   icon: '../../assets/media/wiki/hosting/icon_pwalambda.svg',
        //   url: URLS.AppWikiHostingPwalambda,
        // },
        {
          title: "M2 în Kubernetes",
          icon: '../../assets/media/wiki/hosting/icon_m2kubernetes.svg',
          url: URLS.AppWikiHostingM2kubernetes,
        },
        {
          title: "Stocare & Baze de date",
          icon: '../../assets/media/wiki/hosting/icon_storagedatabases.svg',
          url: URLS.AppWikiHostingStorageDatabase,
        },
        {
          title: "Securitate",
          icon: '../../assets/media/wiki/hosting/icon_security.svg',
          url: URLS.AppWikiHostingSecurity,
        },
        // {
        //   title: "Deployments",
        //   icon: '../../assets/media/wiki/hosting/icon_deployments.svg',
        //   url: '/wiki/hosting/deployments',
        // },
        // {
        //   title: "Cost Tracking",
        //   icon: '../../assets/media/wiki/hosting/icon_costtracking.svg',
        //   url: '/wiki/hosting/cost-tracking',
        // }
      ]
    },
    // {
    //   title: "The Code",
    //   description: [
    //     "Although visitors and shop administrators don't see the code, the solid architecture behind Zento guarantees a fast &amp; reliable solution. If you're a fellow professional, you can read on how we built our solution at Zento.",
    //   ],
    //   articles: [
    //     {
    //       title: "Code Structure",
    //       icon: '../../assets/media/wiki/code/icon_codestructure.svg',
    //       url: '/wiki/code/structure',
    //     },
    //     {
    //       title: "Build Process",
    //       icon: '../../assets/media/wiki/code/icon_build.svg',
    //       url: '/wiki/code/build-process',
    //     },
    //     {
    //       title: "E2E Testing",
    //       icon: '../../assets/media/wiki/code/icon_e2e.svg',
    //       url: '/wiki/code/e2e-testing',
    //     }
    //   ]
    // }
  ];

  componentDidRender() {
    document.title = pageInfo.pageTitle;
    document.querySelector('meta[name="Description"]').setAttribute('content', pageInfo.pageDescription);
    document.querySelector('meta[property="og:description"]').setAttribute('content', pageInfo.pageDescription);
  }

  render() {
    return (
      <div class='wiki-page'>
        <app-meta
          titleStr={pageInfo.pageTitle}
          description={pageInfo.pageDescription}
          keywords={pageInfo.keywords}
          image="assets/icon/var_og-image.png"
          urlKey={pageInfo.pageURL}
        />

        <div class='container'>
          <div class='top-heading'>
            <h3>Zento</h3>
            <h1>Wiki</h1>
            <p>Acest <q>Wiki</q> conține descrieri detaliate care explică viziunea și produsul Zento, cum este el diferit <br /> de o
              soluție tradițională și de ce ar trebui să faci upgrade la Zento.</p>
          </div>

          {AppWiki.data.map(section => {
            return <div class='container-box'>
              <h2>{section.title}</h2>
              {section.description.map(paragraph => {
                return <p>{paragraph}</p>;
              })}
              <ul>
                {section.articles.map(article => {
                  return <li>
                    <stencil-route-link url={article.url}>
                      <img
                        class='img'
                        src={article.icon}
                        alt={article.title}
                        loading='lazy'
                        width='394'
                        height='160'
                      />
                      {article.title}
                    </stencil-route-link>
                  </li>
                })}
              </ul>
            </div>
          })}
        </div>

        <app-contact-us />
      </div>
    );
  }
}
